<div class="hmf-display-flex">
	<button id="shipping-button"
			class="shipping-button hmf-display-flex hmf-my-xxxs hmf-p-xs hmf-align-items-center hmf-subheader-bold-m"
			[ngClass]="{ 'selected' : selected,  'disabled' : disabled}"
			[disabled]="disabled"
			(click)="emitSelctedOption()">
		<div class="label-container">
			<p class="label hmf-subheader-bold-m">{{shippingOption?.label}}</p>
		</div>
	</button>
</div>
